import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createRegisterAdapter } from 'src/app/common-components/register/models/register-state.adapter';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import { multiFieldSort } from '../register-reducer.factory';
import { systemActiveCallsFeatureKey, SystemActiveCallsState } from './system-active-calls.reducer';

const adapter = createRegisterAdapter<ActiveCallsRegisterListItem, any, any>({
   selectId: (item) => item.callDetailId ?? 0,
});

export const selectSystemActiveCallsState = createFeatureSelector<SystemActiveCallsState>(systemActiveCallsFeatureKey);
export const selectors = adapter.getSelectors(selectSystemActiveCallsState);

export const selectOrderingOptions = createSelector(
   selectSystemActiveCallsState,
   (state) => state.orderingOptions ?? []
);

export const selectIsAutoRefresh = createSelector(selectSystemActiveCallsState, (state) => state.isAutoRefresh);

export const selectFilters = createSelector(selectSystemActiveCallsState, (state) => state.filters);

export const selectSortedActiveCalls = createSelector(
   selectors.selectAll,
   selectOrderingOptions,
   (calls, orderingOptions) => multiFieldSort(orderingOptions, calls)
);
